import React from 'react';
import { Analytics } from "@vercel/analytics/react";
import { Header, Footer } from "./LandingPage";
import SEO from './common/SEO';
import LegalDocument from './common/LegalDocument';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col relative">
      <SEO path="/privacy-policy" noindex />
      <Header />
      <main className="flex-1 pt-32">
        <LegalDocument kind="privacy" />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
};

export default PrivacyPolicyPage;
